import {
    validatePassword,
    validateFullName,
    validateEmail,
} from '../signup/utils';

export { validatePassword, validateFullName, validateEmail };

export const HAS_INTEGRATION_OPTIONS = {
    YES: 'yes',
    NO: 'no',
    NOT_SURE: 'not_sure',
};

export const WORKING_WITH_ADVERTISERS_OPTIONS = {
    YES: 'true',
    NO: 'false',
};

export const PARTNER_ERROR_CODES = {
    ERROR_EMAIL_IN_BLACK_LIST: 'ERROR_EMAIL_IN_BLACK_LIST',
    ERROR_REJECTED_EMAIL: 'ERROR_REJECTED_EMAIL',
    ERROR_RECAPTCHA_VALIDATION_FAILED: 'ERROR_RECAPTCHA_VALIDATION_FAILED',
};

export function validateCompanyName(companyName) {
    if (!companyName || !companyName.trim()) {
        return 'Company name is required';
    }
    return null;
}

export function validateEligibility(workingWithAdvertisers, hasLiveIntegration) {
    if (workingWithAdvertisers === false) {
        return 'Partner signup is available for networks that work with Singular advertisers. Please contact us for more information.';
    }
    if (hasLiveIntegration === HAS_INTEGRATION_OPTIONS.YES || hasLiveIntegration === HAS_INTEGRATION_OPTIONS.NOT_SURE) {
        return 'It looks like you may already have an integration with Singular. Please contact our integration team for assistance.';
    }
    return null;
}

export function isValidPartnerForm(validations) {
    return Object.values(validations).every(v => !v);
}
